var XPortal = XPortal || {};
XPortal.SectionDisplayRules = XPortal.SectionDisplayRules || {};

XPortal.SectionDisplayRules.Processing = (function () {
    const self = {
        _minDate: "1970-01-01 ",
        _emptyFieldValueText: "___empty___",
        _multipleValueSeparator: "_#_",
        _currentEntity: 6,
        _parentEntity: 4,
        _curEntityPrefix: "curentity___",
        _filterType:
        {
            Undefined: -1,
            Equal: 0,
            NotEqual: 1,
            StartsWith: 2,
            Contains: 3,
            NotContain: 4,
            EndsWith: 5,
            Unique: 6,
            Less: 30,
            Greater: 40,
            Blank: 50,
            NotBlank: 60
        },
        Init: function (selector) { },
        Process: function (model) {
            return new Promise((onOk, onErr) => {
                const result = { IsValid: true, SectionsDataUpd: [] };
                model.forEach(x => {
                    if (!x.IsUpdated) return;
                    const isections = processSections(x);
                    if (isections)
                        result.SectionsDataUpd.push({ NodeId: x.NodeId, SectionsData: isections });
                });
                if (!result.IsValid) onErr(["No data!"]);
                onOk(result);
            });
        },
        areRulesTrue: function (model, rules, prevRes = true, isFirst = false) {
            if (!rules || !rules.length) return prevRes;

            const rule = rules[0];
            if (!isFirst && ((!rule.IsAnd && prevRes) || (rule.IsAnd && !prevRes))) {
                rules.shift();
                return self.areRulesTrue(model, rules, prevRes);
            }
            const result = processQItems(rule?.Items, model, true, true);
            prevRes = isFirst ? result : (rule.IsAnd ? prevRes && result : prevRes || result);
            rules.shift();

            return self.areRulesTrue(model, rules, prevRes);
        },
        convertHelper: {
            isDate: function (date) {
                return date !== null && (new Date(date) != "Invalid Date") && !isNaN(new Date(date));
            },
            toBase64: function (val) {
                try {
                    return window.btoa(unescape(encodeURIComponent(val)));
                }
                catch {
                    return null;
                }
            },
            toString: function (val, caseSensitive) {
                const res = String(val);
                return res ? (!caseSensitive ? res.toLowerCase() : res).trim() : null;
            },
            toTime: function (val) {
                return self.convertHelper.isDate(self._minDate + val) ? new Date(self._minDate + val).getTime() : null;
            },
            toBoolean: function (val) {
                if (val === "1" || val === "true" || val === "on" || val === true) return true;
                return false;
            },
            toNumber: function (val) {
                return !isNaN(Number(val)) ? Number(val) : null;
            },
            toDateTime: function (val) {
                const timestamp = self.convertHelper.isDate(val) ? XPortal.Grid.ConvertToDate(val, "", true).getTime() : null;
                if (timestamp == null) return timestamp;
                return new Date(timestamp);
            }
        },
        GetFRelatedFields: function (frModel, modelName) {
            let result = [];
            frModel.forEach(function (fr, fri) {
                if (!fr.IsEnabled) return;
                result = result.concat(getFilterFieldNames(fr.Rules, modelName));
            });
            return result;
        }
    };

    function processSections(model) {
        const sectionsVisibility = [];
        if (!model.SectionsData.length) return sectionsVisibility;

        model.SectionsData.forEach(isection => {
            const drModel = JSON.parse(JSON.stringify(isection.DRModel));
            const frModel = JSON.parse(JSON.stringify(isection.FRModel));
            let isVisible = true;

            if ((!drModel || !drModel.IsEnabled || !drModel.Items || !drModel.Items.length) && (!frModel || !frModel.IsEnabled || !frModel.Items || !frModel.Items.length)) {
                sectionsVisibility.push(getSectionData(isection, isVisible, true));
                return;
            }
            const influenceFields = isection.IsProcessed ? isection.InfluenceFields : getInfluenceFields(isection, drModel, frModel);
            if (!isection.IsProcessed) getInfluenceFieldsForFilters(isection, drModel, frModel, model);

            if (!isNeededToBeUpdated(isection, influenceFields, model.ModifiedFields, isection.RelatedFields)) {
                sectionsVisibility.push(JSON.parse(JSON.stringify(isection)));
                return;
            }
            if (isNeededToBeUpdated(isection, isection.DInfluenceFields, model.ModifiedFields, isection.DRelatedFields)) {
                isVisible = self.areRulesTrue(model, drModel.Items, true, true);
            }
            if (frModel.IsEnabled) {
                if (isNeededToBeUpdated(isection, isection.FInfluenceFields, model.ModifiedFields, isection.FRelatedFields)) {
                    let resStyle = "";
                    let resColorStyle = "";
                    let resClasses = "";
                    let removeClasses = "";
                    frModel.Items.forEach((x, ix) => {
                        if (!x.IsEnabled || !x.Rules || !x.Rules.length) {
                            return;
                        }
                        const res = self.areRulesTrue(model, x.Rules, true, true);
                        if (res) {
                            resStyle = (resStyle ? resStyle + ";" : resStyle) + x.StyleCss;
                            resColorStyle = (resColorStyle ? resColorStyle + ";" : resColorStyle) + x.ColorCss;
                            resClasses = resClasses + " " + x.CssClasses;
                        }
                        else {
                            removeClasses = removeClasses + " " + x.CssClasses;
                        }
                    });
                    resStyle = resStyle.trim();
                    isection.Style = resStyle ? resStyle + ";" : resStyle;
                    isection.ColorCss = resColorStyle ? resColorStyle + ";" : resColorStyle;
                    isection.Classes = resClasses;
                    isection.RemoveClasses = removeClasses;
                }
            }

            sectionsVisibility.push(getSectionData(isection, isVisible, true));
        });
        return sectionsVisibility;
    };
    function getInfluenceFields(sdata, drModel, frModel) {
        sdata.DInfluenceFields = getDRInfluenceFields(drModel) || [];
        sdata.FInfluenceFields = getFRInfluenceFields(frModel) || [];
        return sdata.InfluenceFields = _.unique(sdata.DInfluenceFields.concat(sdata.FInfluenceFields));
    };

    function getInfluenceFieldsForFilters(sdata, drModel, frModel, model) {
        sdata.DRelatedFields = getDRelatedFields(drModel, model) || [];
        sdata.FRelatedFields = getFRelatedFields(frModel, model) || [];
        return sdata.RelatedFields = sdata.DRelatedFields.concat(sdata.FRelatedFields);
    };
    function getDRelatedFields(drModel, model) {
        let result = [];
        if (!drModel || !drModel.Items || !drModel.Items.length) return null;
        result = getFilterFieldNames(drModel.Items, model.ModelName);
        return result;
    };
    function getFRelatedFields(frModel, model) {
        let result = [];
        if (!frModel || !frModel.Items || !frModel.Items.length) return null;
        frModel.Items.forEach(function (fr, fri) {
            if (!fr.IsEnabled) return;
            result = result.concat(getFilterFieldNames(fr.Rules, model.ModelName));
        });
        return result;
    };
    function getFilterFieldNames(items, modelName) {
        let result = [];
        (items || []).forEach(function (item, i) {
            if (!item.Items.length) return;
            item.Items.forEach((itm, ix) => {
                let res = getRelatedFieldAndModelName(modelName, itm);
                if (res) result.push(res);
            });
        });
        return result;
    };


    function getFRInfluenceFields(frModel) {
        let result = [];
        if (!frModel || !frModel.Items || !frModel.Items.length) return null;
        frModel.Items.forEach(function (fr, fri) {
            if (!fr.IsEnabled) return;
            result = result.concat(getFieldNames(fr.Rules));
        });
        return _.unique(result);
    };
    function getDRInfluenceFields(drModel) {
        let result = [];
        if (!drModel || !drModel.Items || !drModel.Items.length) return null;
        result = result.concat(getFieldNames(drModel.Items));
        return _.unique(result);
    };
    function getFieldNames(items) {
        let result = [];
        (items || []).forEach(function (item, i) {
            if (!item.Items.length) return;
            result.push(...item.Items.map(x => trimStart(x.FieldName, "srt_").toLowerCase()));
        });
        return result;
    };
    function trimStart(str, strToTrim) {
        str = str || "";
        return str.startsWith(strToTrim) ? str.slice(strToTrim.length) : str;
    };
    function isNeededToBeUpdated(sectionData, influenceFields, modifiedFields, relatedFields) {
        if (!sectionData.IsProcessed) return true;
        const mfields = modifiedFields.filter(x => x.IsUpdated).map(x => x.Name.toLowerCase());
        return (influenceFields?.find(x => mfields.includes(x.toLowerCase())) ?? 0) != 0 || relatedFields.length;
    };
    function processQItems(ruleItems, model, result, isFirst = false) {
        if (!ruleItems || !ruleItems.length) return result;
        ruleItems.forEach(function (rule, ri) {
            const { fieldValue, fieldType } = getFieldValueAndDTypeByFName(model, rule, rule.FieldName);
            const ruleValue = getFieldValueForFilter(model, rule);
            const defaultValue = rule.PreCalcValue == 1 ? true : false;
            let res = defaultValue;
            if ((!fieldValue && !fieldType) || !ruleValue) res = defaultValue;
            else {
                const fieldValues = _.isString(fieldValue) ? (fieldValue ?? "").split("_#_") : (_.isArray(fieldValue) ? fieldValue : [fieldValue]);
                for (var i = 0; i < fieldValues.length; i++) {
                    res = isRuleTrue(rule, fieldValues[i], fieldType, model, ruleValue);
                    if (res) break;
                }
            }
            if (res != null) {
                result = isFirst ? res : (rule.IsAnd ? result && res : result || res);
                isFirst = false;
            }
            if (res == null && isFirst) isFirst = true;
            result = processQItems(rule?.Items, model, result, isFirst);
        });
        return result;
    };
    function isRuleTrue(rule, fieldValue, fieldType, model, ruleValue) {
        const { rvalue, fvalue } = prepareValue(ruleValue, fieldValue, fieldType, rule.CaseSensitive);
        return compareValues(fvalue, rvalue, rule);
    };
    function prepareValue(rvalue, fvalue, type, caseSensitive) {
        type = type.toLowerCase();
        if (type == "date" || type == "datetime") {
            rvalue = self.convertHelper.toDateTime(rvalue);
            fvalue = self.convertHelper.toDateTime(fvalue);
        }
        else if (type == "decimal" || type == "int32" || type == "int64") {
            rvalue = self.convertHelper.toNumber(rvalue);
            fvalue = self.convertHelper.toNumber(fvalue);
        }
        else if (type == "boolean") {
            rvalue = self.convertHelper.toBoolean(rvalue);
            fvalue = self.convertHelper.toBoolean(fvalue);
        }
        else if (type == "time" || type == "timespan") {
            rvalue = self.convertHelper.toTime(rvalue);
            fvalue = self.convertHelper.toTime(fvalue);
        }
        else if (type == "base64") {
            rvalue = self.convertHelper.toBase64(rvalue);
            fvalue = self.convertHelper.toBase64(fvalue);
        }
        else {
            rvalue = self.convertHelper.toString(rvalue, caseSensitive);
            fvalue = self.convertHelper.toString(fvalue, caseSensitive);
        }
        return { rvalue, fvalue };
    };
    function compare(a, b) {
        if (a < b) return -1;
        else if (a > b) return 1;
        return 0;
    };
    function compareValues(fieldValue, rvalue, rule) {
        const fvalues = fieldValue && fieldValue.indexOf && fieldValue.indexOf(self._multipleValueSeparator) > -1 ? (fieldValue || "").split(self._multipleValueSeparator) : [fieldValue];
        let res = true;
        let isAnd = rule.IsAnd;
        let isFirst = true;
        fvalues.forEach((fvalue, ix) => {
            const resCompare = compare(fvalue || "", rvalue || "");
            fvalue = fvalue || "";
            rvalue = rvalue || "";

            switch (rule.FilterType || self._filterType.Equal) {
                case self._filterType.Equal:
                    res = getResult(res, (rule.Not ? resCompare != 0 : resCompare == 0), isAnd, isFirst);
                    break;
                case self._filterType.Greater:
                    res = getResult(res, (rule.IncludeLower ? resCompare >= 0 : resCompare > 0), isAnd, isFirst);
                    break;
                case self._filterType.Less:
                    res = getResult(res, (rule.IncludeUpper ? resCompare <= 0 : resCompare < 0), isAnd, isFirst);
                    break;
                case self._filterType.Contains:
                    res = getResult(res, (fvalue.includes && fvalue.includes(rvalue)), isAnd, isFirst);
                    break;
                case self._filterType.NotContain:
                    res = getResult(res, (!(fvalue.includes && fvalue.includes(rvalue))), isAnd, isFirst);
                    break;
                case self._filterType.EndsWith:
                    res = getResult(res, (fvalue.endsWith(rvalue)), isAnd, isFirst);
                    break;
                case self._filterType.StartsWith:
                    res = getResult(res, (fvalue.startsWith(rvalue)), isAnd, isFirst);
                    break;
                default:
                    res = res && false;
            }
            isAnd = false;
            isFirst = false;
        });
        return res;
    };
    function getResult(res, curRes, isAnd, isFirst) {
        if (isFirst) return curRes;
        return isAnd ? res && curRes : res || curRes;
    };
    function getSectionData(sd, isVisible, isProcessed) {
        const res = JSON.parse(JSON.stringify(sd));
        res.IsVisible = isVisible;
        res.IsProcessed = isProcessed;
        return res;
    };
    function getFieldValueForFilter(model, rule) {
        const fvalueSttgs = rule.FilterValue;
        const ftype = fvalueSttgs.FilterType;
        const tvals = fvalueSttgs.TemplateValues;
        const fname = tvals && tvals.length ? tvals[0] : null;
        if (fvalueSttgs.FilterType == 2) {
            getFieldValueAndDTypeByFName(model, rule, fname)
        }
        if (ftype != self._currentEntity && ftype != self._parentEntity) {
            return rule.Value;
        }
        
        const modelName = model.ModelName;
        if (ftype == self._currentEntity) {
            const { fieldValue, fieldType } = getFieldValueAndDTypeByFName(model, rule, fname);
            return fieldValue;
        }
        else if (ftype == self._parentEntity) {
            const parentModel = getParentModel(modelName, fvalueSttgs.SourceParentAlias);
            if (!parentModel || !parentModel.entity) return;
            const { fieldValue, fieldType } = getFieldValueAndDTypeByFName(parentModel.entity, rule, fname);
            return fieldValue;
        }
        return;
    };
    function getRelatedFieldAndModelName(modelName, rule) {
        const fvalueSttgs = rule.FilterValue;
        const ftype = fvalueSttgs.FilterType;
        if (ftype != self._currentEntity && ftype != self._parentEntity) {
            return null;
        }
        const tvals = fvalueSttgs.TemplateValues;
        const fname = tvals && tvals.length ? tvals[0] : null;
        if (ftype == self._currentEntity)
            return { fname, modelName, key: fname + modelName };
        else if (ftype == self._parentEntity) {
            const parentModel = getParentModel(modelName, fvalueSttgs.SourceParentAlias);
            if (!parentModel || !parentModel.entity) return null;
            const pmname = parentModel.model.modelName;
            return { fname, modelName: pmname, key: fname + pmname };
        }
        return null;
    };
    function getParentModel(modelName, alias) {
        let maxCount = 50;
        let pmodel = null;
        do {
            modelName = XPortal.Store.GetParentModelName(modelName);
            pmodel = modelName ? XPortal.Store.GetModelByName(modelName) : null;
            maxCount--;

        } while (alias && modelName && modelName.length && maxCount && (pmodel.model.EntityAlias.toLowerCase() != alias.toLowerCase()));
        return pmodel;

    };
    function getFieldValueAndDTypeByFName(model, rule, fieldName) {
        fieldName = trimStart(fieldName, "srt_").toLowerCase();
        const fieldsData = model.ModifiedFields || model.Fields;
        let modField = fieldsData?.find(x => x.Name.toLowerCase() === fieldName);
        if (!modField && model.hasOwnProperty(fieldName))
            modField = { Value: model[fieldName], Type: "String" };
        if (!modField) return { fieldValue: null, fieldType: null };
        let fieldValue = typeof (model[fieldName]) !== "undefined" ? modField.Value || model[fieldName] : modField.Value;
        if (typeof (fieldValue) === "string") fieldValue = fieldValue.trim();
        if (typeof (fieldValue) === "string" && !fieldValue?.length) fieldValue = self._emptyFieldValueText;
        const fieldType = modField.Type || "String";
        return { fieldValue, fieldType };
    };

    return self;
}());

